import React from "react";
import Seo from "../components/Seo";

const H2 = ({ children }) => (
  <h2 className="text-lg md:text-xl font-bold text-slate-900 mt-10 mb-3">{children}</h2>
);
const P = ({ children }) => <p className="text-slate-600 leading-relaxed mb-3">{children}</p>;

export default function MentionsLegalesPage() {
  return (
    <main data-testid="mentions-legales-page" className="bg-white">
      <Seo
        title="Mentions légales | Thermasol Air Systems®"
        description="Mentions légales du site thermasol-airsystems.fr — France Énergie SAS, marque Thermasol Air Systems®."
        canonical="https://thermasol-airsystems.fr/mentions-legales/"
      />
      <section className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900">Mentions légales</h1>
          <p className="text-slate-500 mt-3 text-sm">Dernière mise à jour : juin 2026</p>

          <H2>1. Éditeur du site</H2>
          <P>
            Le site <strong>thermasol-airsystems.fr</strong> est édité par <strong>France Énergie SAS</strong>,
            société par actions simplifiée, exploitant la marque <strong>Thermasol Air Systems®</strong>.
          </P>
          <ul className="text-slate-600 leading-relaxed mb-3 list-disc pl-6 space-y-1">
            <li>Siège social : 13 rue des Vignes, 91330 Yerres, France</li>
            <li>SIRET : 899 346 217 00024 — RCS Évry 899 346 217</li>
            <li>Code APE : 3511Z — Production d'électricité</li>
            <li>TVA intracommunautaire : FR56 899 346 217</li>
            <li>Téléphone : <a href="tel:0184190449" className="text-orange-600 underline">01 84 19 04 49</a></li>
            <li>Email : <a href="mailto:contact@thermasol-airsystems.fr" className="text-orange-600 underline">contact@thermasol-airsystems.fr</a></li>
          </ul>
          <P>Directeur de la publication : le représentant légal de France Énergie SAS.</P>

          <H2>2. Hébergement</H2>
          <P>
            Le site est hébergé sur une infrastructure cloud opérée par Emergent (plateforme d'hébergement
            d'applications), avec diffusion et sécurisation via Cloudflare, Inc., 101 Townsend Street,
            San Francisco, CA 94107, États-Unis — <a href="https://www.cloudflare.com" target="_blank" rel="noopener noreferrer" className="text-orange-600 underline">www.cloudflare.com</a>.
          </P>

          <H2>3. Propriété intellectuelle</H2>
          <P>
            L'ensemble du contenu du site (textes, images, schémas, logos, documents téléchargeables) est la
            propriété exclusive de France Énergie SAS ou de ses partenaires. <strong>Thermasol Air Systems®</strong>{" "}
            est une marque déposée. La technologie hybride PVT air est déposée à l'INPI. Toute reproduction,
            représentation ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite.
          </P>

          <H2>4. Aides et dispositifs CEE</H2>
          <P>
            Les informations relatives aux Certificats d'Économies d'Énergie (notamment la fiche AGRI-EQ-110) sont
            fournies à titre indicatif. L'éligibilité et le montant des primes dépendent de la réglementation en
            vigueur et de l'examen de chaque dossier ; ils sont confirmés par écrit avant toute signature.
          </P>

          <H2>5. Responsabilité</H2>
          <P>
            France Énergie SAS s'efforce d'assurer l'exactitude des informations publiées, sans garantir
            l'absence d'erreurs ou d'omissions. Les simulations, calculettes et estimations proposées sur le site
            n'ont pas de valeur contractuelle : seule une étude technique personnalisée fait foi.
          </P>

          <H2>6. Données personnelles et cookies</H2>
          <P>
            Le traitement des données personnelles collectées sur ce site est décrit dans notre{" "}
            <a href="/politique-confidentialite" className="text-orange-600 underline" data-testid="link-privacy-from-legal">
              Politique de confidentialité
            </a>
            . Vous pouvez gérer votre consentement aux cookies à tout moment via le lien « Cookies » en bas de page.
          </P>

          <H2>7. Droit applicable</H2>
          <P>
            Les présentes mentions légales sont régies par le droit français. En cas de litige, et à défaut de
            résolution amiable, les tribunaux du ressort du siège social de l'éditeur seront compétents.
          </P>
        </div>
      </section>
    </main>
  );
}
